define.alias("shared/components/shared/ui/cluster-switcher", "calendar/components/shared/ui/cluster-switcher");